import React from 'react';
import { aboutFounder } from '../data/mock';
import { Sparkles } from 'lucide-react';

const FounderSection = () => {
  return (
    <section id="founder" className="py-24 lg:py-32 bg-[#FFFEF8]">
      <div className="max-w-7xl mx-auto px-6 lg:px-12">
        <div className="grid lg:grid-cols-2 gap-16 lg:gap-24 items-center">
          {/* Content */}
          <div className="order-2 lg:order-1">
            <p className="text-sm tracking-[0.2em] text-[#6B8F71] mb-4 uppercase">
              {aboutFounder.subtitle}
            </p>
            
            <h2 className="text-3xl lg:text-4xl font-light text-[#333333] mb-8">
              {aboutFounder.title}
            </h2>
            
            <div className="space-y-6">
              {aboutFounder.paragraphs.map((paragraph, index) => (
                <p key={index} className="text-base text-[#666666] leading-relaxed">
                  {paragraph}
                </p>
              ))}
            </div>

            {/* Expertise indicators */}
            <div className="mt-10 flex flex-wrap gap-4">
              {['Crystal Healing', 'Energy Work', 'Spiritual Guidance'].map((skill) => (
                <div
                  key={skill}
                  className="flex items-center gap-2 px-4 py-2 bg-[#F8F7F2] text-[#4A4A4A] text-sm"
                >
                  <Sparkles className="w-4 h-4 text-[#B8A88A]" />
                  {skill}
                </div>
              ))}
            </div>
          </div>

          {/* Photo */}
          <div className="order-1 lg:order-2">
            <div className="relative">
              <img
                src={aboutFounder.image}
                alt="Dr. Achira Sanyal"
                className="w-full h-[450px] lg:h-[550px] object-cover object-top"
              />
              <div className="absolute -bottom-4 -left-4 w-24 h-24 border border-[#6B8F71]/30" />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default FounderSection;
